const RegularExpressions = {
  validateUrl:
    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
  numberOnly: /^[0-9]+$/,
  alphabetsOnly: /^[a-zA-Z ]+$/,
  alphaNumberic: /^[a-zA-Z0-9_. ]*$/,
  phoneNumber: /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/,
  rtmpValidateUrl: /rtmp.*?@(.*?):(\d+)\/(\w+)\/(\w+)/,
  ipAddressRegex:
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  userName: /^[a-zA-Z0-9_]{3,16}$/,
};

export default RegularExpressions;
